import { IncentivioRouteObject } from 'pages/main-routes';

export const getSidebarFromRoutes = (
  startNode: IncentivioRouteObject,
  startPath = '/',
) =>
  startNode.children?.reduce((result, childNode) => {
    if (!!childNode.handle?.page?.sidebar) {
      const to = childNode.path
        ? `${startPath}${startPath === '/' ? '' : '/'}${childNode.path}`
        : startPath;
      result.push({
        ...childNode.handle.page.sidebar,
        title: childNode.handle.page.title,
        to,
        children: getSidebarFromRoutes(childNode, to),
      });
    }
    return result;
  }, []) ?? [];
